const DomainUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:8000"
    : "https://system1.rotanaegypttravel.com");

export default DomainUrl;
